"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyProvider = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var overlays_1 = require("@react-aria/overlays");
var deepmerge_1 = __importDefault(require("deepmerge"));
var i18next_1 = __importDefault(require("i18next"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var common_translations_1 = require("../core/common-translations");
var components_1 = require("../core/components");
var theme_1 = require("../core/theme");
function EnergyProvider(_a) {
    var _b = _a.components, clientComponents = _b === void 0 ? {} : _b, links = _a.links, _c = _a.modify, modify = _c === void 0 ? {} : _c, _d = _a.i18nConfig, i18nConfig = _d === void 0 ? {} : _d, clientTheme = _a.theme, config = _a.config, _e = _a.analytics, analytics = _e === void 0 ? {
        trackers: [],
    } : _e, _f = _a.subscriptions, subscriptions = _f === void 0 ? [] : _f, useNavigateHook = _a.useNavigateHook, feature = _a.feature, clientIcons = _a.icons, children = _a.children;
    core_1.configService.setConfig(config);
    var i18nFallbackNS = i18nConfig.fallbackNS;
    var fallbackNS = !i18nFallbackNS
        ? 'cp-ui-tools'
        : typeof i18nFallbackNS == 'string'
            ? [i18nFallbackNS, 'cp-ui-tools']
            : __spreadArray(__spreadArray([], __read(i18nFallbackNS), false), ['cp-ui-tools'], false);
    // Temporary workaround to include basic AUS-specific overrides.
    var resources = i18nConfig.resources, i18nConfigRest = __rest(i18nConfig, ["resources"]);
    var mergedResources = (0, deepmerge_1.default)(config.retailer.region === 'AUS'
        ? { en: { translation: common_translations_1.overridesAUS } }
        : {}, resources || {});
    i18next_1.default.use(react_i18next_1.initReactI18next).init(__assign(__assign({ lng: 'en', resources: mergedResources }, i18nConfigRest), { interpolation: {
            escapeValue: false,
        }, fallbackNS: fallbackNS }));
    var components = __assign(__assign({}, core_1.overrideableComponents), clientComponents);
    var theme = clientTheme || (0, core_1.createTheme)();
    var analyticsData = __assign(__assign({}, analytics.data), { isBootstrapped: true, version: "16.1.3" });
    if (config.kaluzaDiagnosticsKey) {
        analytics.trackers.unshift(core_1.internalTracker);
    }
    var linksWithDefaults = __assign(__assign({}, core_1.linkDefaults), links);
    var icons = __assign(__assign({}, theme_1.icons), clientIcons);
    return (react_1.default.createElement(ui_tools_1.NavigateProvider, { useNavigateHook: useNavigateHook },
        react_1.default.createElement(ui_tools_1.AnalyticsProvider, { data: analyticsData, trackers: analytics.trackers },
            react_1.default.createElement(ui_tools_1.EventsProvider, { subscriptions: subscriptions },
                react_1.default.createElement(ui_tools_1.SandwichProvider, { modify: modify },
                    react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
                        react_1.default.createElement(nebula_1.IconsProvider, { icons: icons },
                            react_1.default.createElement(ui_tools_1.LinkProvider, { links: linksWithDefaults },
                                react_1.default.createElement(components_1.ComponentsProvider, { components: components },
                                    react_1.default.createElement(ui_tools_1.CustomerProvider, null,
                                        react_1.default.createElement(ui_tools_1.AccountProvider, null,
                                            react_1.default.createElement(core_1.FeatureProvider, __assign({}, feature),
                                                react_1.default.createElement(overlays_1.OverlayProvider, null, children)))))))))))));
}
exports.EnergyProvider = EnergyProvider;
